import React from 'react';

const Drop = () => {
    return (
      <React.Fragment>
        {/* Start Drop*/}
        <div className="btn__base r4c2">
          <div className="btn">
            <div className="numbox">
              <div className="num">
                <div className="arrow">
                  <div className="arrow-top"></div>
                  <div className="arrow-mid"></div>
                  <div className="arrow-btm"></div>
                </div>
              </div>
              <div className="btm"></div>
            </div>
          </div>
        </div>
        {/* End Drop */}
      </React.Fragment>
    );
  };

export default Drop;